<div class="documents">
  <h2>Upload Document</h2>

  <div
    class="documents__dropzone"
    appDragAndDrop
    (fileDropped)="handleFileInput($event)"
    [matTooltip]="'Max file size: 25MB, Allowed formats: ' + allowedFormats"
    matTooltipPosition="above">
    <input
      type="file"
      class="documents__dropzone--input"
      [accept]="allowedFormats"
      (change)="handleFileInput($event.target)" />
    <span class="material-symbols-outlined documents__dropzone--icon">cloud_upload</span>
    <span class="documents__dropzone--info">Drag and drop file here</span>
    <span class="documents__dropzone--file-name">{{ documentName || 'No file selected' }}</span>
    <button class="documents__dropzone--browse" mat-stroked-button>Browse for file</button>
  </div>

  <div class="documents__actions">
    <mat-form-field>
      <mat-label>Choose Category</mat-label>
      <mat-select [formControl]="categoryControl">
        @for (category of categories$ | async; track category.key) {
          <mat-option [value]="category.key">{{ category.displayName }}</mat-option>
        }
      </mat-select>
      @if (categoryControl.hasError('required')) {
        <mat-error>Category is required</mat-error>
      }
    </mat-form-field>
    @if (isUploading) {
      <button mat-stroked-button disabled>Uploading</button>
    } @else {
      <button mat-flat-button (click)="upload()">Upload</button>
    }
    <button mat-stroked-button (click)="clear()">Clear</button>
  </div>
</div>
